import type { ICanvas } from "./Interfaces";
import { assetsURI, cartItemElementId, categoryId, productId, settingsElementId } from "./Stores";

export class NCFields {

    private static _instance: NCFields;

    public wizData: DOMStringMap;

    public fetchingId: string;

    public settingsField: HTMLTextAreaElement;
    public cartItemIdField: HTMLInputElement;

    public editMode: boolean;
    public attributesSection: HTMLElement;
    public priceSection: HTMLElement;

    private constructor() {
        this.setStoreVariables("wizard");
        this.setFetchingId(this.wizData["productId"], this.wizData["categoryId"]);
        this.hideAttributeSections(".overview .attributes", ".overview .product-price");
        this.removeButtonsSection(".overview-buttons");
    }

    public static Instance() {
        return this._instance || (this._instance = new this());
    }

    private setStoreVariables(wizardElementId: string) {
        this.wizData = (document.getElementById(wizardElementId) as HTMLDivElement).dataset;

        // Note: set productId and settingsElementId is used in CallToActionButtons components

        let settingsFieldId = this.setSettingsField(this.wizData["settingsField"]);
        settingsElementId.set(settingsFieldId);

        let cartItemIdField = this.setCartItemIdField(this.wizData["cartItemField"]);
        cartItemElementId.set(cartItemIdField);

        productId.set(this.wizData["productId"]);
        categoryId.set(this.wizData["categoryId"]);
        assetsURI.set(this.wizData["assetsLoc"]);
    }

    private setFetchingId(productId: string, categoryId: string) {
        if (categoryId === null || categoryId === undefined || categoryId === "" || categoryId === "0")
            this.fetchingId = productId;
        else
            this.fetchingId = "c" + categoryId;
    }

    private hideAttributeSections(selector: string, priceSectionSelector: string) {
        // hide all attributes viz. settings
        var attributeSection = document.querySelector(selector) as HTMLElement;
        if (attributeSection) {
            this.attributesSection = attributeSection;
            attributeSection.remove();
            attributeSection.querySelectorAll('dd').length >= 1 && this.duplicatePriceSection(priceSectionSelector);
        }
    }

    private duplicatePriceSection(selector: string) {
        // hide all attributes viz. settings
        var priceSection = document.querySelector(selector) as HTMLElement;
        if (priceSection) {
            this.priceSection = priceSection.cloneNode(true) as HTMLElement;
            priceSection.id = "";
            // priceSection.remove();
        }
    }

    private removeButtonsSection(selector: string) {
        var overviewbuttonSection = document.querySelector(selector) as HTMLElement;
        overviewbuttonSection && overviewbuttonSection.remove();
    }

    private setSettingsField(fieldId: string) {
        // if fieldId is null or empty, use 'settings' as its value
        (fieldId === null || fieldId === "") && (fieldId = "settings");

        // check if settings field exists and create one if not
        let field = document.getElementById(fieldId) as HTMLTextAreaElement;
        if (field === null || field === undefined) {
            field = document.createElement("textarea") as HTMLTextAreaElement;
        }
        else {
            let labelDtHtmlId = fieldId.replace("product_attribute", "product_attribute_label");
            let inputDdHtmlId = fieldId.replace("product_attribute", "product_attribute_input");
            let labelDtHtmlElement = document.getElementById(labelDtHtmlId);
            let inputDdHtmlElement = document.getElementById(inputDdHtmlId);

            field.remove();
            labelDtHtmlElement && labelDtHtmlElement.remove();
            inputDdHtmlElement && inputDdHtmlElement.remove();
        }

        this.settingsField = field;
        this.settingsField.id = fieldId;
        this.settingsField.name = fieldId;

        return fieldId;
    }

    private setCartItemIdField(fieldId: string) {
        // if fieldId is null, set field to null
        if (fieldId === null || fieldId === "") {
            this.cartItemIdField = null;
            this.editMode = false;
            return;
        }

        // check if settings field exists and if not, set field to null
        let field = document.getElementById(fieldId) as HTMLInputElement;
        if (field === null || field === undefined) {
            this.cartItemIdField = null;
            this.editMode = false;
            return;
        }

        field.remove();

        this.editMode = field.value ? true : false;

        this.cartItemIdField = field;
        this.cartItemIdField.id = fieldId;
        this.cartItemIdField.name = fieldId.replace("_U", ".U");
        this.cartItemIdField.type = "hidden";

        return fieldId;
    }

    public appendSettingsField(targetId: string): HTMLTextAreaElement {
        return document.getElementById(targetId).appendChild(this.settingsField);
    }

    public getSettings(): ICanvas {
        if (!this.settingsField.value) {
            throw new Error("Settings missing!");
        }

        return JSON.parse(this.settingsField.value);
    }

    public setSettings(canvas: ICanvas): void {
        this.settingsField.value = JSON.stringify(canvas);
    }

    public updateSettingsFieldId(fieldId: string): void {
        if (this.settingsField && fieldId) {
            this.settingsField.id = fieldId;
            this.settingsField.name = fieldId;
        }
        else throw new Error("Loading settings failed!")
    }

    public hasProductChanged(productId: string): boolean {
        return this.wizData["productId"] != productId;
    }

    public appendAttributesAndPriceToSection(ProductId: string, destinationAttributesSection: HTMLElement): void {
        let fnName = `attribute_change_handler_${ProductId}`;

        let attributeChanges = () => {
            typeof window[fnName] === "function" && window[fnName]();
        };

        if (
            this.attributesSection &&
            this.attributesSection.querySelectorAll(
                "input,textarea,select-one,select-multiple"
            ).length >= 1
        ) {
            this.attributesSection.querySelectorAll("input").forEach((el) => {
                (el.type === "checkbox" || el.type === "radio") &&
                    (el.onclick = () => attributeChanges());
                // for file upload controls there's no type=file attribute 
                // but there is a type=hidden
                if (el.type === "hidden") {
                    var attributeId = el.id.replace("product_attribute_", "");
                    var scriptTemplate = document.getElementById(`product_attribute_${attributeId}-qq-template`);
                    scriptTemplate
                        && scriptTemplate.nextElementSibling
                        && window.eval((scriptTemplate.nextElementSibling as HTMLScriptElement).innerText);
                }
            });
            this.attributesSection.querySelectorAll("select").forEach((el) => {
                el.onchange = () => attributeChanges();
            });
            destinationAttributesSection.appendChild(this.attributesSection);
            destinationAttributesSection.appendChild(this.priceSection);
        }
    }
}